export default "__VITE_ASSET__DAQjTpuv__"